import React, { useEffect, useRef, useState } from 'react';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { IN_PRODUCTION_STATUSES, STATUS_LABELS } from '../constants';

// Row overflow for In Production (Corrections spec 8.5).
//
// Deliberately absent: "Move to…" — production stories are not Suggestions and
// cannot be moved (8.2). Also absent: the per-row "Who writes" dropdown, which
// 8.2 removes because writing responsibility is configuration-derived.
export default function InProductionRowMenu({
  item, onCorrectStatus, onCopyTo, onAction, configUrl, onOpenBucket,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const run = (fn) => { setOpen(false); fn(); };

  return (
    <div style={{ position: 'relative' }} ref={ref}>
      <button className="pbnew-icon-btn" title="More" onClick={() => setOpen((v) => !v)}>
        <MoreHorizOutlinedIcon style={{ fontSize: 18 }} />
      </button>
      {open && (
        <div className="pbnew-menu" style={{ top: 28, right: 0, minWidth: 210 }}>
          <button className="pbnew-menu-item" onClick={() => run(onCopyTo)}>
            <ContentCopyOutlinedIcon style={{ fontSize: 16 }} /> Copy to…
          </button>
          <button className="pbnew-menu-item" onClick={() => run(() => onAction(item, 'copy_story'))}>
            <ContentCopyOutlinedIcon style={{ fontSize: 16 }} /> Copy story title + link
          </button>
          <div className="pbnew-menu-sep" />

          {/* Spec 8.4 — explicit canonical status correction, distinct from the
              click-to-advance on the status cell. */}
          <div className="pbnew-menu-label">Correct status to</div>
          {IN_PRODUCTION_STATUSES.filter((s) => s !== item.status).map((s) => (
            <button key={s} className="pbnew-menu-item" onClick={() => run(() => onCorrectStatus(item, s))}>
              {STATUS_LABELS[s]}
            </button>
          ))}
          <div className="pbnew-menu-sep" />

          <button className="pbnew-menu-item" onClick={() => run(onOpenBucket)}>
            <LaunchOutlinedIcon style={{ fontSize: 16 }} /> Open in Bucket Stories
          </button>
          <a
            className="pbnew-menu-item"
            href={configUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
          >
            <SettingsOutlinedIcon style={{ fontSize: 16 }} /> Configure bucket
          </a>
          <div className="pbnew-menu-sep" />

          <button className="pbnew-menu-item" onClick={() => run(() => onAction(item, 'archive'))}>
            <ArchiveOutlinedIcon style={{ fontSize: 16 }} /> Archive
          </button>
          {/* Spec 8.2 — "Remove" is renamed Delete. */}
          <button className="pbnew-menu-item danger" onClick={() => run(() => onAction(item, 'delete'))}>
            <DeleteOutlineOutlinedIcon style={{ fontSize: 16 }} /> Delete
          </button>
        </div>
      )}
    </div>
  );
}
